import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalPoliceDomesticViolenceModel } from './types';
import { legalPoliceDomesticViolenceItemValidator } from './validators/item';

const legalPoliceDomesticViolenceValidator: ValidateJSModel<LegalPoliceDomesticViolenceModel> = {
  // For HasDomesticViolence, validation is the same for both PVQ and non-PVQ
  HasDomesticViolence: { presence: true, hasValue: { validator: hasYesOrNo } },
  // Validation is the same for both PVQ and non-PVQ
  List: (value, attributes) => {
    if (attributes?.HasDomesticViolence?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalPoliceDomesticViolenceItemValidator },
      };
    }

    return {};
  },
};
export default legalPoliceDomesticViolenceValidator;
